import _ from 'lodash'
import { reject, flow, mapValues, flatMap, map, uniqBy, isPlainObject, isEmpty, endsWith } from 'lodash/fp'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { ModalHeader, ModalBody } from 'reactstrap'
import styled from 'styled-components'

import { validateApplication } from 'e-submission/apps/actions'
import { getAuraInvalidField } from 'e-submission/apps/selectors'
import EditCard from 'e-submission/components/Card/EditCard'
import Dialog from 'e-submission/components/Dialog'
import { getIcon } from 'e-submission/components/Icon'
import Content from 'e-submission/components/Layout/Content'
import { getToggles } from 'quick-quote/feature-toggles'

const Status = styled.div`
  text-align: center;
  padding: 30px 0px;
  div:last-child {
    padding-top: 30px;
  }
`

const HookComponent = function() {
  const history = useHistory()
  const dispatch = useDispatch()

  const appState = useSelector((state) => {
    return {
      invalid: getAuraInvalidField(state),
    }
  })

  useEffect(() => {
    dispatch(validateApplication())
  }, [])

  const invalid = mapValues(
    ({ sections, label }) => ({
      label,
      fields: flow(
        map(({ id, fields, label, heading }) => {
          if (endsWith(']', id)) {
            return heading
          }

          if (!isEmpty(label)) {
            return label
          }

          return { id, fields }
        }),
        reject(isEmpty),
        uniqBy((value) => (isPlainObject(value) ? value.id : value)),
        flatMap((value) => (isPlainObject(value) ? map('label', value.fields) : value))
      )(sections),
    }),
    appState.invalid
  )

  const toggle = () => history.push(_.keys(invalid)[0])
  const onClickEdit = (pageId) => {
    history.push(pageId)
    dispatch(validateApplication())
  }
  return <Dialog className={''} isOpen={!_.isEmpty(invalid)}>
    <ModalHeader toggle={toggle}>
      <div>กรอกข้อมูลไม่ครบ</div>
    </ModalHeader>
    <ModalBody>
      <Status>
        {getIcon('formInvalid')}
        <div>
          ไม่สามารถสร้างเอกสารได้
          <br />
          <b>กรุณากลับไปแก้ไขข้อมูลด้านล่างให้สมบูรณ์</b>
        </div>
      </Status>
      <Content>
        {_.map(invalid, ({ fields, label }, pageId) => (
          <EditCard key={pageId} title={label} onClick={() => onClickEdit(pageId)}>
            <ul>
              {_.map(fields, (label, index) => (
                <li key={index}>
                  {getToggles().ENABLE_SHARED_AGENT_SALE_VALIDATION && pageId === 'agent' && label === 'นายหน้า'
                    ? 'กรุณาตรวจสอบสิทธิการขายของตัวแทนอีกท่าน'
                    : label}
                </li>
              ))}
            </ul>
          </EditCard>
        ))}
      </Content>
    </ModalBody>
  </Dialog>
}

export default HookComponent
